import type { ReactNode } from 'react';
import { PaginaAvulsa } from '@inscricao/components/PaginaAvulsa';

/**
 * Aviso de privacidade, versao curta.
 *
 * Existe para a coleta poder ser ligada antes da politica completa, que esta
 * com o Gustavo. Diz o minimo que a LGPD pede no momento da coleta: quem
 * recebe, o que, para que, com quem e compartilhado, por quanto tempo, e como
 * exercer os direitos. Quando a politica completa ficar pronta, ela substitui
 * esta pagina no mesmo endereco.
 *
 * Tudo aqui foi conferido contra o que o sistema faz de fato em 20/10/2026.
 * Se o sistema mudar (outro servico, outro destinatario, outro dado), este
 * texto muda junto, e a versao abaixo sobe.
 */
export const VERSAO_DO_AVISO = '2026-10-20';
/*
  Canal do encarregado. PROVISORIO desde 27/10/2026: o e-mail
  privacidade@hcrmbrasil.com.br ainda nao recebe mensagens (falta o
  redirecionamento no ImprovMX), entao o canal publicado e a mensagem direta
  do Instagram do curso. Quando o e-mail funcionar, troque so este objeto.
*/
export const CANAL_DO_ENCARREGADO = {
  rotulo: 'mensagem direta no Instagram @hcrm_brasil',
  endereco: 'https://www.instagram.com/hcrm_brasil/',
};

function Bloco({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <section className="border-t border-linha pt-5 first:border-t-0 first:pt-0">
      <h2 className="display-item">{titulo}</h2>
      <div className="mt-2 space-y-2 text-apoio leading-relaxed text-tinta-suave">{children}</div>
    </section>
  );
}

export function PaginaPrivacidade() {
  return (
    <PaginaAvulsa titulo="Aviso de privacidade" largura="max-w-2xl">
      <div className="space-y-6">
        <Bloco titulo="Quem cuida dos seus dados">
          <p>
            A coordenação da Imersão HCRM. O encarregado pelo tratamento de dados é Gustavo
            Fernandes Moreira, que atende por{' '}
            <a href={CANAL_DO_ENCARREGADO.endereco} target="_blank" rel="noopener" className="text-destaque underline underline-offset-2">
              {CANAL_DO_ENCARREGADO.rotulo}
            </a>
            .
          </p>
        </Bloco>

        <Bloco titulo="O que coletamos">
          <p>
            No cadastro para receber avisos: nome, e-mail e WhatsApp. No cadastro institucional,
            também cargo e organização.
          </p>
          <p>
            Junto com isso guardamos a data e a hora do seu aceite, a versão do texto que você
            aceitou e em qual parte da página você clicou.
          </p>
        </Bloco>

        <Bloco titulo="Para que usamos">
          <p>
            Para avisar sobre as inscrições desta e das próximas turmas da Imersão HCRM, por
            e-mail e WhatsApp. No cadastro institucional, para a coordenação conversar com você
            sobre a formação da sua equipe.
          </p>
          <p>
            A base é o seu consentimento, dado ao marcar a caixa do formulário. Não usamos seus
            dados para nenhuma outra finalidade e não os vendemos nem cedemos a ninguém.
          </p>
        </Bloco>

        <Bloco titulo="Quem tem acesso">
          <p>
            A coordenação da Imersão HCRM, que recebe um resumo diário por e-mail com os novos
            cadastros.
          </p>
          <p>
            Dois serviços participam do funcionamento, sem usar os dados para fins próprios: o
            Supabase, onde os dados ficam guardados, em servidores em São Paulo, e o Resend, que
            envia os e-mails.
          </p>
          <p>
            As inscrições serão feitas pelo HCX, no ambiente dele. Seus dados deste cadastro não
            são repassados ao HCX.
          </p>
        </Bloco>

        <Bloco titulo="Por quanto tempo">
          <p>Até você pedir para sair. Ao sair, seus dados são apagados.</p>
        </Bloco>

        <Bloco titulo="Seus direitos">
          <p>
            Para sair da lista a qualquer momento, use a página{' '}
            <a href="/sair" className="text-destaque underline underline-offset-2">
              Sair da lista
            </a>
            : você digita seu e-mail e recebe um link para confirmar.
          </p>
          <p>
            Para saber quais dados temos sobre você, corrigir algum deles ou tirar qualquer
            dúvida, fale com o encarregado por{' '}
            <a href={CANAL_DO_ENCARREGADO.endereco} target="_blank" rel="noopener" className="text-destaque underline underline-offset-2">
              {CANAL_DO_ENCARREGADO.rotulo}
            </a>
            .
          </p>
        </Bloco>

        <Bloco titulo="Navegação no site">
          <p>
            O site não usa cookies nem ferramentas de rastreamento. As fontes do texto são
            carregadas do Google Fonts, que recebe o endereço de acesso do seu navegador ao
            entregá-las.
          </p>
        </Bloco>

        <p className="border-t border-linha pt-5 text-miudo text-tinta-fraca">
          Versão de {VERSAO_DO_AVISO.split('-').reverse().join('/')}. Este é um aviso resumido; a
          política de privacidade completa vai substituí-lo neste mesmo endereço.
        </p>
      </div>
    </PaginaAvulsa>
  );
}
